import { useTranslation } from 'react-i18next';
import { CaretRight, DotsThree } from '@phosphor-icons/react';
import type { BreadcrumbItemDto } from '@monorepo/shared';
import { truncatePath } from './breadcrumbTruncation';

interface ParentPathBreadcrumbProps {
  items: BreadcrumbItemDto[];
  onNavigate: (nodeId: string) => void;
}

export const ParentPathBreadcrumb = ({ items, onNavigate }: ParentPathBreadcrumbProps) => {
  const { t } = useTranslation();

  if (items.length === 0) {
    return <span className="text-gray-400">{t('documents.parent_path.none')}</span>;
  }

  const { leading, hidden, trailing, isTruncated } = truncatePath(items, 1, 1);
  const separator = <CaretRight size={12} className="text-gray-400 shrink-0" />;

  const renderItem = (item: BreadcrumbItemDto) => (
    <button
      onClick={() => onNavigate(item.id)}
      className="text-gray-500 hover:text-primary transition-colors truncate max-w-[140px]"
    >
      {item.name}
    </button>
  );

  if (!isTruncated) {
    return (
      <span className="flex items-center gap-1 min-w-0">
        {items.map((item, index) => (
          <span key={item.id} className="flex items-center gap-1 min-w-0">
            {index > 0 && separator}
            {renderItem(item)}
          </span>
        ))}
      </span>
    );
  }

  return (
    <span className="flex items-center gap-1 min-w-0">
      {renderItem(leading[0])}
      {separator}
      <span
        className="flex items-center text-gray-400"
        title={hidden.map((item) => item.name).join(' › ')}
      >
        <DotsThree size={16} weight="bold" />
      </span>
      {separator}
      {renderItem(trailing[0])}
    </span>
  );
};
